<div class="p-grid p-m-1">
	<div class="p-col">
		<p-card styleClass="analyse-card" header="Flexgebieden">
			<p>
				<button pButton pRipple
						type="button"
						icon="fa fa-plus"
						label="Nieuw flexgebied"
						class="p-button-secondary p-button-text p-button-outlined p-button-rounded p-mr-2"
						(click)="newProject()"></button>
			</p>

			<p-table #dt
					 [styleClass]="'xxfullwidth'"
					 dataKey="id"
					 (onRowSelect)="onRowSelect($event)"
					 (onRowUnselect)="onRowUnselect($event)"
					 [value]="projects"
					 [columns]="columns"
					 [loading]="loading"
					 sortField="id"
					 [sortOrder]="-1"
					 [globalFilterFields]="fields"
					 [rows]="10"
					 [rowsPerPageOptions]="[10,25,50,100,250]"
					 [responsive]="true"
					 [autoLayout]="true"
					 [paginator]="true"
					 [showPageLinks]="false"
					 [paginatorDropdownAppendTo]="'body'"
					 [alwaysShowPaginator]="false"
					 [showCurrentPageReport]="false">

				<ng-template pTemplate="header" let-columns>
					<tr>
						<ng-container *ngFor="let col of columns">
							<th [pSortableColumn]="col.field">
								<div class="p-d-flex p-ai-center p-jc-between">
									<span>{{col.header}}</span>
									<p-sortIcon [field]="col.field"></p-sortIcon>
								</div>
							</th>
						</ng-container>
						<th>
							Haltes inladen
						</th>
					</tr>
					<tr>
						<ng-container *ngFor="let col of columns">
							<th *ngIf="col.field !== 'last_update' && col.field !== 'sum_hours'">
								<input pInputText type="text"
									   (input)="searchColumn($event.target, col.field, 'startsWith')"
									   [placeholder]="'Zoeken op ' + col.header" class="p-column-filter p-inputtext-sm">
							</th>
						</ng-container>
						<th>
							<div *ngIf="loadingQuaysInProgress" class="text-sm">
								<div class="flex flex-row align-items-center">
									<button pButton pRipple
											type="button"
											pTooltip="Bezig haltes in te laden. Tot dit klaar is zijn overige laad-acties geblokkeerd."
											icon="fa fa-spin fa-spinner"
											label="Ververs status"
											class="p-button-secondary p-button-text p-button-outlined p-button-rounded p-mr-2"
											(click)="$event.stopPropagation(); refreshLoadingStatus()"></button>
								</div>
							</div>

						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item let-columns="columns">
					<tr class="p-selectable-row" (click)="onRowClick(item)">
						<ng-container *ngFor="let col of columns">
							<td *ngIf="col.field !== 'last_update' && col.field !== 'sum_hours'">
								<span class="p-column-title">{{col.header}}</span>
								{{item[col.field]}}
								<span *ngIf="item[col.field] === null"
									  class="p-text-italic p-text-uppercase">-</span>
							</td>
						</ng-container>
						<td>
							<button pButton pRipple
									type="button"
									[disabled]="loadingQuaysInProgress"
									icon="fa fa-download"
									label="Laad haltes in uit CHB"
									class="p-button-secondary p-button-text p-button-outlined p-button-rounded p-mr-2"
									(click)="$event.stopPropagation(); loadQuays(item)"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="summary">

				</ng-template>

				<ng-template pTemplate="paginatorleft">
				</ng-template>

				<ng-template pTemplate="paginatorright">
				</ng-template>

				<ng-template pTemplate="emptymessage" let-columns>
					<tr>
						<td [attr.colspan]="columns.length + 1">Geen projecten gevonden.</td>
					</tr>
				</ng-template>
			</p-table>

		</p-card>
	</div>
</div>

<p-sidebar position="right"
		   [style]="{width:'35rem'}"
		   [showCloseIcon]="true"
		   [(visible)]="showProjectSidebar"
		   [blockScroll]="true">
	<div>
		<h1 class="p-m-0 p-pb-1">Bewerk project {{ selectedProject?.name}}</h1>
	</div>
	<project-detail
		[inputProject]="selectedProject"
		(discardRequest)="discardProject($event)"
		(updateRequest)="updateProject($event)"
	>
	</project-detail>
</p-sidebar>

<p-confirmDialog #cd [style]="{width: '30rem'}" [baseZIndex]="10000">
	<ng-template pTemplate="footer">
		<button pButton pRipple type="button" label="Nee"
				class="p-button-secondary p-button-text p-button-rounded p-mr-2"
				(click)="cd.reject()"></button>

		<button pButton pRipple type="button" label="Ja, verwijder"
				class="p-button-rounded p-text-uppercase"
				(click)="cd.accept()"></button>
	</ng-template>
</p-confirmDialog>